import { z } from 'zod';
import { v4 } from 'uuid';
import { units } from '@/service/recipe/types';

// One document per item, so family members editing different items at the
// same time don't overwrite each other
export const GrocerySchema = z.object({
  id: z.string().default(() => v4()),
  text: z.string().default(''),
  done: z.boolean().default(false),
  amount: z.number().positive().optional(),
  unit: z.enum([...units, '']).optional(),
  recipeId: z.string().optional(),
  createdAt: z.number().default(() => Date.now()),
  user: z.string().optional(),
});

export type Grocery = z.infer<typeof GrocerySchema>;
export type GroceryUnit = Grocery['unit'];
export type GroceryInput = z.input<typeof GrocerySchema>;
export type GroceryChanges = Partial<
  Pick<Grocery, 'text' | 'done' | 'amount' | 'unit'>
>;
